import { TypedUseSelectorHook, useSelector } from 'react-redux';
import type { IRootState } from 'Source/Store';

// Use throughout your app instead of plain `useSelector`
export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector;
